import { HttpAxiosRequest } from '../httpAxiosBase'
import { EntityWithIdAndDescription } from '../../types'
import { SistemaPrincipal } from '../../types/workflow/cache'
import {Sistema} from "../../pages/messages/types";

export const HttpSystemsNewByGroup = {
    getEndpoint: (url = '') => `grupo/sistemas${url}`,

    getSystemTypes: (): Promise<EntityWithIdAndDescription[]> =>
        HttpAxiosRequest.get(HttpSystemsNewByGroup.getEndpoint('/tipos')),

    getSystemPrincipals: (): Promise<SistemaPrincipal[]> =>
        HttpAxiosRequest.get(HttpSystemsNewByGroup.getEndpoint('/principales')),

    getSystemsByCountry: (countryCode: number) : Promise<Sistema[]> =>
        HttpAxiosRequest.get(HttpSystemsNewByGroup.getEndpoint(`/${countryCode}`)),
}
